import { defineMessages } from 'react-intl';

// This contains all the translatable interface messages.
const messages = defineMessages({
  'table-firstTitle': {
    id: 'V5MN6t',
    defaultMessage: 'Multi-Zone Region',
  },
  'table-secondTitle': {
    id: '3i7Hau',
    defaultMessage: 'Data Center',
  },
  'table-thirdTitle': {
    id: 'yHztb1',
    defaultMessage: 'Federal Data Center',
  },
  'table-fourthTitle': {
    id: 'EpJRRQ',
    defaultMessage: 'Network PoP',
  },
  'table-row1': {
    id: 'bOaynN',
    defaultMessage: 'Washington, DC',
  },
  'table-row2': {
    id: 'U+wBOG',
    defaultMessage: 'Dallas',
  },
  'table-row3': {
    id: 'vnNLRC',
    defaultMessage: 'San Jose',
  },
  'table-row5': {
    id: 'Eww+Ll',
    defaultMessage: 'Los Angeles',
  },
  'table-row6': {
    id: 'i1GA35',
    defaultMessage: 'Seattle',
  },
  'table-row7': {
    id: 'qr2sKL',
    defaultMessage: 'Denver',
  },
  'table-row8': {
    id: 'JVuVOx',
    defaultMessage: 'Chicago',
  },
  'table-row9': {
    id: 'ZxG5bx',
    defaultMessage: 'Atlanta',
  },
  'table-row10': {
    id: 'NwfCZN',
    defaultMessage: 'New York City',
  },
  'table-row11': {
    id: '5/ZVcj',
    defaultMessage: 'Miami',
  },
  'table-row12': {
    id: 'WaZD9I',
    defaultMessage: 'Toronto',
  },
  'table-row13': {
    id: '7z9Vs4',
    defaultMessage: 'Montreal',
  },
  'table-row14': {
    id: '7ybQi0',
    defaultMessage: 'São Paulo',
  },
  'table-row15': {
    id: 'L5VdMS',
    defaultMessage: 'Frankfurt',
  },
  'table-row16': {
    id: 'deoXOL',
    defaultMessage: 'Madrid',
  },
  'table-row17': {
    id: 'YekgnB',
    defaultMessage: 'London',
  },
  'table-row18': {
    id: 'UfMD1l',
    defaultMessage: 'Paris',
  },
  'oslo-row': {
    id: '91KBuU',
    defaultMessage: 'Oslo',
  },
  'stockholm-row': {
    id: 'ftH7ii',
    defaultMessage: 'Stockholm',
  },
  'table-row19': {
    id: 'qFismH',
    defaultMessage: 'Amsterdam',
  },
  'table-row20': {
    id: 'LKUXOw',
    defaultMessage: 'Milan',
  },
  'table-row21': {
    id: 'mWF7RS',
    defaultMessage: 'Tokyo',
  },
  'table-row22': {
    id: '7I4cik',
    defaultMessage: 'Osaka',
  },
  'table-row23': {
    id: 'JFYhZv',
    defaultMessage: 'Hong Kong',
  },
  'table-row24': {
    id: 'sKrQGP',
    defaultMessage: 'Taipei',
  },
  'table-row25': {
    id: 'wFfaY4',
    defaultMessage: 'Seoul',
  },
  'table-row26': {
    id: 'rhaGlx',
    defaultMessage: 'Singapore',
  },
  'table-row27': {
    id: 'Hl6eet',
    defaultMessage: 'Chennai',
  },
  'table-row28': {
    id: 'OgF6Am',
    defaultMessage: 'Mumbai',
  },
  'table-row29': {
    id: 'Dg2c3+',
    defaultMessage: 'Sydney',
  },
  'table-row30': {
    id: 'wYcYcy',
    defaultMessage: 'Melbourne',
  },
  'table-row31': {
    id: '0/kcGP',
    defaultMessage: 'Perth',
  },
});

export default messages;
